module.exports = __webpack_public_path__ + "img/ai-poweredHero.d5955c2b.svg";